import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './MainPageBlock.css';
import SeeAllButton from '../../../App/Common/SeeAllButton/SeeAllButton';
import TaskCard from '../../../App/Common/Cards/TaskCard/TaskCard';
import CourseCard from '../../../App/Common/Cards/CourseCard/CourseCard';
import OpenedBlock from '../../../App/Common/BlocksWithCards/OpenedBlock/OpenedBlock';
import LockedTaskCard from '../../../App/Common/Cards/LockedTaskCard/LockedTaskCard';
import Calendar from '../../../Calendar/Calendar';

import { useCookies } from 'react-cookie';
import api from '../../../../Utils/Api';


const MainPageBlock = ({ title, cardType, data, link, loading }) => {
    const [cookies, setCookie, removeCookie] = useCookies(['token']);
    const [token, setToken] = useState(cookies.token ? cookies.token : undefined);
    const [tab, setTab] = useState(false);
    const [titleTag, setTitleTag] = useState('');
    const [tests, setTests] = useState([]);
    const [tasks, setTasks] = useState([])
    
    useEffect(() => {
        api.getActualTasks(token).then((res) => {
            console.log(res)
            setTasks(res)
        })
        setTests(extractTests());
    }, []);
    
    useEffect(() => {
        setTests(extractTests());
    }, [data]);

    const getTime = (date) => {
        const fullDate = new Date(date);
        const hours = fullDate.getHours();
        const minutes = fullDate.getMinutes();
        return `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')}`;
    };

    const getDate = (date) => {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        return `${day.toString().padStart(2, '0')}.${(month + 1).toString().padStart(2, '0')}`;
    };

    const handleOpenTab = (title) => {
        if (title === 'Мои курсы') {
            setTab(false);
            setTitleTag('_courses');
        } else if (title === 'Календарь') {
            setTab(true);
            setTitleTag('_calendar');
        }
    };

    // console.log(tests)

    const extractTests = (course) => {
        console.log(course)
        if (!course?.roadMap?.topics) return [];
        return course.roadMap.topics.flatMap((topic) =>
            topic.lessons.flatMap((lesson) =>
                lesson.steps.flatMap((step) => {
                    if (step.type === 'test' && step.test) {
                        return [{ ...step.test, type: 'test', course: course }];
                    } else if (step.type === 'exercise' && step.exercise) {
                        return [{ ...step.exercise, type: 'exercise', course: course }];
                    }
                    return [];
                })
            )
        );
    };

    const handleNumMaterial = (d) => {
        const theme =  d.roadMap.topics.map((el) => el)
        const lesson = d.roadMap.topics.reduce((acc, el) => acc + el.lessons.length, 0);        // setMaterial({theme: theme.length, lessen: lesson.length})
        return {theme: theme.length, lesson: lesson}
    }

    const handleTheme = (d) => {
        const totalTopics = d.roadMap.topics.length;
        const percent = d.roadMap.topics.reduce((acc, el) => acc + el.percent_completed, 0) / totalTopics;
        return Math.round(percent)
    }

    return (
        <>
            <div className='tab__wrap'>
                <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Мои курсы')}>Мои курсы</div>
                {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
            </div>

            {tab ? (
                <div className='openedBlock__container'>
                    <Calendar />
                </div>
            ) : (
                <OpenedBlock title={title} link={link}>
                     {loading ? ( <div className="mainPage__preloader">
                <div className="spinner">Загрузка...</div>
                </div>) : (<>
                    <div className='mainPageBlock__cards'>
                        {cardType === 'task'
                            ? data.map((item, index) =>
                                  item.is_blocked || item.is_blocked === null ? (
                                      <LockedTaskCard
                                          key={index}
                                          title={item.title}
                                          description={item.description}
                                          progress={item.attempts_left ? `${item.attempts_left} попытки` : undefined}
                                          totalTests={item.total_tests}
                                          deadline={item.days_left}
                                      />
                                  ) : (
                                      <TaskCard
                                          key={index}
                                          title={item.title}
                                          description={item.description}
                                          progress={item.attempts_left ? `${item.attempts_left} попытки` : undefined}
                                          totalTests={item.total_tests}
                                          deadline={item.conference_id > 0 ? undefined : item.days_left}
                                          link={`/resource/${item.step_id}`}
                                          type={item.conference_id > 0 ? 'Видеоурок' : undefined}
                                          confTime={item.conference_id > 0 ? getTime(item.start_time) : undefined}
                                          confDate={item.conference_id > 0 ? getDate(item.start_time) : undefined}
                                      />
                                  )
                              )
                            : data.map((item, index) => {
                                console.log(item)
                                let mat = null;
                                let percent = null;
                                if (item.roadMap) {
                                    mat = handleNumMaterial(item)
                                    percent = handleTheme(item)
                                }
                                // console.log(mat)
                                  return item ? (
                                      <CourseCard
                                            course={item}
                                            key={index}
                                            title={item.title}
                                            image={item.image}
                                            progress={item.completed_tests}
                                            totalTests={item.total_tests}
                                            average={`${item.avg}%`}
                                            link={item.completed_tests === 'n' ? `/performance/${item.id}` : `course/${item.id}`}
                                            material={mat !== null? mat : null}
                                            percent={percent}
                                      />
                                  ) : null}
                              )}
                    </div>

                    <Link className='seeAllButton__link' to={'/courses'}>
                        <div className='seeAllButton'>Смотреть все курсы</div>
                    </Link>

                    <div className='openedBlock__block'>
                        <p>Актуальные задания</p>
                        <div className='mainPageBlock__list'>
                            {/* {data.flatMap((test, index) => {
                                const tests = extractTests(test);
                                console.log(tests)
                                return tests.map((el, subIndex) => (
                                    <Link to={`/resource/${el.step_id}`} key={`${index}-${subIndex}`}>{el.title}</Link>
                                ));
                            })} */}
                            {tasks.length === 0 ? (
                                <div>В данный момент нет актуальных заданий</div>
                            ) : (
                                tasks.map((el, index) => {
                                    console.log(el);
                                    return (
                                        <Link to={`/resource/${el.step_id}`} key={`${el.id}`}>
                                            <span>{el.title}</span>
                                            <div className='mainPageBlock__link'>{el.step_type === 'test' ? 'Тест' : 'Упражнение'}</div>
                                        </Link>
                                    );
                                })
                            )}
                        </div>
                    </div>
                    </>)}
                </OpenedBlock>
            )}
        </>
    );
};

export default MainPageBlock;
